<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <span style="line-height: 40px;margin-right:10px">操作时间</span>
      <el-date-picker
        clearable
        value-format="yyyy-MM-dd"
        @change="onTimeChange()"
        v-model="times"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"/>
      <el-input
        v-model="body.keyword"
        clearable
        @change="handleCurrentChange()"
        class="input-with-select dk_input">
        <el-button
          @click="handleCurrentChange()"
          slot="append"
          icon="el-icon-search"/>
      </el-input>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="idd"
        label="编号"/>
      <el-table-column
        prop="name"
        label="管理员姓名"/>
      <el-table-column
        prop="create_time"
        label="操作时间"/>
      <el-table-column
        prop="desc"
        label="操作内容"/>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

  </el-main>
</template>

<script>
import { getAdminLog } from '../../api/system'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      updateTitle: '新增',
      updateDialog: false,
      addBogy: {
        priority: '',
        name: '',
      },
      body: {
        keyword: '',
        page_index: 1,
        page_size: 20,
      },
      times: [],
      total: 0,
      tableData: [
      ],
    };
  },

  components: {
  },
  created() {
    this.network().getAdminLog()
  },
  methods: {
    handleCurrentChange() {
      this.network().getAdminLog()
    },
    event() {
      return {
        toAddClick: () => {
          this.$router.push({ path: '/logistics-management/add' })
        },
        toDetailClick: () => {
          this.$router.push({ path: '/logistics-management/detail' })
        },
        onUpdateClick: () => {
          this.updateDialog = true
        },
      }
    },
    network() {
      return {
        getAdminLog: async () => {
          this.body.start_time = this.body.begin_time
          const { status, data } = await getAdminLog(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/system/log-list.vue